import {
  AdditiveBlending,
  BackSide,
  Color,
  Mesh,
  MeshBasicMaterial,
  SphereGeometry,
} from 'three';

/**
 * Soft sky tint shell — low opacity so suns stay readable.
 */
export function createAtmosphere(scene) {
  const geo = new SphereGeometry(1, 40, 28);
  const mat = new MeshBasicMaterial({
    color: 0x3a6a88,
    transparent: true,
    opacity: 0.06,
    side: BackSide,
    blending: AdditiveBlending,
    depthWrite: false,
  });
  const mesh = new Mesh(geo, mat);
  mesh.visible = false;
  mesh.renderOrder = -3;
  scene.add(mesh);

  const tint = new Color(0x3a6a88);

  return {
    setVisible(v) {
      mesh.visible = v;
    },
    setTint(hex) {
      tint.setHex(hex);
      mat.color.copy(tint);
    },
    setOpacity(o) {
      mat.opacity = o;
    },
    /**
     * @param {import('../bodies/CelestialBody.js').CelestialBody} planet
     * @param {number} [scale]
     */
    update(planet, scale = 36) {
      if (!mesh.visible || !planet) return;
      mesh.position.copy(planet.position);
      mesh.scale.setScalar(scale);
    },
    dispose() {
      scene.remove(mesh);
      geo.dispose();
      mat.dispose();
    },
  };
}
